import Icon from "@/icons";
import UserBottom from "./Bottom/User";
import { Link } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";

export default function HomeSidebar({ socket, isOpen }: { socket: any, isOpen: Number }) {

    const isActive = (path: string) => {
        return window.location.pathname === path;
    }
    const queryClient = useQueryClient();
    const user = queryClient.getQueryState(["user"]) as any;
    const friendRequests = user?.data?.friends?.filter((friend: any) => friend.status === "pending" && friend.createdBy !== user?.data?.user.id);

    return (
        <div className={`sm:p-4 sm:h-full flex flex-col sm:gap-8 ${isOpen == 2 ? ' z-10 sm:pb-0 flex' : 'hidden sm:flex'}`}>
            <div className={`flex-col shadow-2xl sm:rounded-lg h-full bg-brand-dark  sm:relative min-w-72 transition-all duration-300 ease-linear`}>

                <div className="flex px-2 py-8 h-12">
                    <h1 className="text-gray-300 font-semibold text-sm">Home</h1>
                </div>
                <div className="flex flex-col gap-2 p-2 py-2 flex-grow">
                    <Link to="/" className={`text-gray-300 hover:text-white flex items-center gap-2 p-2 rounded-lg hover:bg-brand-darkest cursor-pointer ${isActive('/') ? 'bg-brand-darkest' : ''}`}>
                        <Icon name="applications" size="32" />
                        <h1 className="text-gray-300 font-semibold text-lg hover:text-white">My Teams</h1>
                    </Link>
                    <Link to="/discover/tournaments" className={`text-gray-300 hover:text-white flex items-center gap-2 p-2 rounded-lg hover:bg-brand-darkest cursor-pointer ${isActive('/discover/tournaments') ? 'bg-brand-darkest' : ''}`}>
                        <Icon name="trophy" size="32" />
                        <h1 className="text-gray-300 font-semibold text-lg hover:text-white">Tournaments</h1>
                    </Link>
                    <Link to="/discover/teams" className={`text-gray-300 hover:text-white flex items-center gap-2 p-2 rounded-lg hover:bg-brand-darkest cursor-pointer ${isActive('/discover/teams') ? 'bg-brand-darkest' : ''}`}>
                        <Icon name="users" size="32" />
                        <h1 className="text-gray-300 font-semibold text-lg hover:text-white">Discover Teams</h1>
                    </Link>
                    <Link to="/me/friends" className={`text-gray-300 hover:text-white flex items-center gap-2 p-2 rounded-lg hover:bg-brand-darkest cursor-pointer ${isActive('/me/friends') ? 'bg-brand-darkest' : ''}`}>
                        <div className="w-full justify-between flex items-center">
                            <div className="flex items-center gap-2">
                                <Icon name="users" size="32" />
                                <h1 className="text-gray-300 font-semibold text-lg hover:text-white">Friends</h1>
                            </div>
                            {friendRequests.length > 0 && (
                                <div className="flex items-center justify-center right-0 top-0 w-4 h-4 bg-brand-green rounded-full">
                                    <p className="text-white text-xs font-semibold">
                                        {friendRequests?.length > 9 ? '9+' : friendRequests?.length}
                                    </p>
                                </div>
                            )}
                        </div>

                    </Link>
                    <hr className="border-gray-600" />

                    <Link to="/me/applications" className={`text-gray-300 hover:text-white flex items-center gap-2 p-2 rounded-lg hover:bg-brand-darkest cursor-pointer ${isActive('/me/applications') ? 'bg-brand-darkest' : ''}`}>
                        <Icon name="applications" size="32" />
                        <h1 className="font-semibold text-lg">
                            My Applications
                        </h1>
                    </Link>
                </div>
            </div>
            <div className="mt-auto">
                <UserBottom user={user.data} socket={socket} />
            </div>
        </div>
    );
}
